export default "__VITE_ASSET__DiFEUetr__"